import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import config from './config';

export const authProvider = new MsalAuthProvider({
    auth: {
        authority: "https://login.microsoftonline.com/maersk.onmicrosoft.com",
        clientId: config.clientId

    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: 'true',
    }
},
    {

        Scopes: ['User.Read']
    },
LoginType.Redirect
);